import CrudTemplate from "../crudTemplate";
import TipoPagamentoService from "../../services/resource/tipoPagamentoService";

export default function TipoPagamentoCrud() {
    const service = new TipoPagamentoService();

    const formFields = [
        { name: "id", label: "ID", type: "input", disabled: true, typeText: "number", colSpan: 1 },
        { name: "nome", label: "Nome", type: "input", colSpan: 1 },
        { name: "descricao", label: "Descrição", type: "input", colSpan: 2 },
    ];

    const tableColumns = [
        { key: "nome", label: "Nome", bold: true },
        { key: "descricao", label: "Descrição" },
    ];

    return <CrudTemplate
        title="Gerenciar Tipos de Pagamento"
        formFields={formFields}
        tableColumns={tableColumns}
        service={service}
        style={{ width: '85%' }}
        modalHeader="Tipo de Pagamento"
    />;
}
